export default __webpack_public_path__ + "static/13-9a5f21aa55efea3678239c86774437c9.jpg";